import styled from 'styled-components';

import { flexRowSpaceBetween } from 'styles/mixins';
import { COLORS } from 'styles/style-constants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 1.6rem;
`;

export const Header = styled.div`
    ${flexRowSpaceBetween};
    margin-bottom: 0.5rem;
`;

export const Label = styled.span`
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${COLORS.textGray};
`;

export const Sum = styled.span`
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${COLORS.textTertiary};
`;

export const Pillar = styled.div`
    display: flex;
    width: 100%;
    height: 0.8rem;
    border-radius: 0.8rem;
    background: ${COLORS.gray100};
`;

export const IceLine = styled.div<{ $width: number; $hasDiceVotes: boolean }>`
    display: flex;
    width: ${({ $width }) => `${$width}%`};
    height: 0.8rem;
    border-radius: ${({ $hasDiceVotes }) => (!$hasDiceVotes ? '0.8rem' : '0.8rem 0 0 0.8rem')};
    border-right: ${({ $hasDiceVotes }) =>
        !$hasDiceVotes ? 'none' : `0.1rem solid ${COLORS.white}`};
    background: ${COLORS.blue500};
`;

export const DiceLine = styled.div<{ $width: number; $hasIceVotes: boolean }>`
    display: flex;
    width: ${({ $width }) => `${$width}%`};
    height: 0.8rem;
    border-radius: ${({ $hasIceVotes }) => ($hasIceVotes ? '0 0.8rem 0.8rem 0' : '0.8rem')};
    background: ${COLORS.purple900};
`;
